<script setup lang="ts">
import { defineProps, ref, watch } from 'vue'
import type { FormItemError } from '@/services/api'

interface Props {
  errors: FormItemError[] | undefined
  haveErrors: boolean
}

const props = defineProps<Props>()

const displayErrors = ref<FormItemError[]>()
const showErrors = ref<boolean>(false)

watch(props, () => {
  displayErrors.value = props.errors
  showErrors.value = props.haveErrors
})
</script>
<template>
  <v-alert v-if="showErrors" dense outlined type="error" class="form-error-alert">
    <ul>
      <li v-for="(error, idx) in displayErrors" :key="idx" v-html="error.message"></li>
    </ul>
  </v-alert>
</template>
<style lang="scss" scoped>
.form-error-alert {
  margin-bottom: 0.5rem;
}
</style>
